export class SignUpUser {
  password: string;
  email: string;
  passwordConfirmation: string;
  firstName: string;
  lastName: string;
  destinationURL = ''
  role: string
}
